<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageFanz.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageFanz.card.general')" cols="12 6@desktop">
        <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>
        <hm-card-inner v-if="!hasRole('ROLE_SYSADMIN')">
          <hm-col cols="12">
            <p>Diese Funktion befindet sich noch in der Erprobungsphase und kann nur von unserem Support-Team aktiviert werden.</p>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner :disabled="!hasRole('ROLE_SYSADMIN')">
          <hm-input-toggle :label="$t('admin.interfaces.pageFanz.enabled')"
                           :help="$t('admin.interfaces.pageFanz.enabled_help')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           :disabled="isEmpty(config.customerId) || isEmpty(config.apiToken)"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input :label="$t('admin.interfaces.pageFanz.customerId')"
                    v-model="config.customerId"
                    cols="12 6@hd start-1"
                    name="customerId" />
          <hm-input :label="$t('admin.interfaces.pageFanz.apiToken')"
                    v-model="config.apiToken"
                    cols="12 6@hd start-1"
                    name="apiToken" />
        </hm-card-inner>
      </card>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { isNil } from 'lodash';

export default {
  name: 'PageFanz',
  components: { HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.interfaces.fanz.get(this, this.interfaceId), this.config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();

            try {
              if (typeof response.data.data.enabled === 'boolean') this.config.enabled = response.data.data.enabled;
            } catch (ignore) { /* ignore */ }
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();

            try {
              if (typeof error.response.data.data.enabled === 'boolean') this.config.enabled = error.response.data.data.enabled;
            } catch (ignore) { /* ignore */ }
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      interfaceId: this.$route.params.interfaceId,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.fanz.get(this, null))
        .then((response) => {
          this.config = response.data.data;
        });
    },
    connect() {
      this.axios.post(this.serviceUrls.interfaces.fanz.connect(this, null))
        .then((response) => {
          window.open(response.data.data.authorizationUrl, '_blank');
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageFanz.vue